interface IFlatData {
  id: string;
  text: string;
  parent: string;
  isGroup?: boolean;
}

interface ITreeData {
  id: string;
  label: string;
  parent: string;
  children: ITreeData[];
  isGroup?: boolean;
  skipParent?: boolean;
}

export const convertToTree = (items: IFlatData[]): ITreeData[] => {
  const treeData: ITreeData[] = [];

  const rootItems = items.filter((i) => i.parent === '#');
  for (const item of rootItems) {
    const treeItem: ITreeData = {
      ...item,
      label: item.text,
      children: recurseTreeData(items, item.id),
    };
    treeData.push(treeItem);
  }

  return treeData;
};

const recurseTreeData = (items: IFlatData[], parentId: string): ITreeData[] => {
  const treeData: ITreeData[] = [];

  const childItems = items.filter((i) => i.parent === parentId);
  for (const item of childItems) {
    const treeItem: ITreeData = {
      ...item,
      label: item.text,
      children: recurseTreeData(items, item.id),
    };
    treeData.push(treeItem);
  }

  return treeData;
};

export const pruneTree = (items: ITreeData[]) => {
  const itemsToRemove = [];

  for (const item of items) {
    if (item.children.length > 0) {
      item.children = pruneTree(item.children);
    }
    if (item.isGroup && item.children.length === 0) {
      itemsToRemove.push(item);
    }
  }

  for (const itemToRemove of itemsToRemove) {
    items = items.filter((i) => i.id !== itemToRemove.id);
  }

  return items;
};

export const hideParentCheckbox = (items: ITreeData[]) => {
  for (const item of items) {
    if (item.children.length > 0) {
      item.skipParent = true;
      hideParentCheckbox(item.children);
    }
  }
};
